var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManual = function SvgManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.402 14.161c.001-.461.224-1.164.694-1.75.463-.577 1.138-1.011 2.036-1.011h8.47v16.088h-8.47c-1.075 0-1.953.178-2.571.595a2.342 2.342 0 0 0-.16.117V14.16Zm-.8.005c0-.461-.223-1.167-.695-1.755-.462-.577-1.138-1.011-2.036-1.011h-8.47v16.088h8.47c1.076 0 1.953.178 2.571.595.056.037.109.076.16.117V14.166Zm0 15.834h.8c0-.592.209-.987.605-1.254.425-.286 1.113-.457 2.125-.457h9.27v-17.69h-9.27c-1.189 0-2.079.586-2.66 1.312a4.155 4.155 0 0 0-.47.735 4.166 4.166 0 0 0-.47-.736c-.582-.725-1.472-1.31-2.66-1.31h-9.27v17.688h9.27c1.01 0 1.699.172 2.124.458.396.267.606.662.606 1.254Zm8.4-14.6h-4v-.8h4v.8Zm-4 3h4v-.8h-4v.8Zm2.5 3h-2.5v-.8h2.5v.8Z",
    fill: "currentColor"
  })));
};
export default SvgManual;